/**
 * Test IDs for QA automation.
 */
export const testIds = {
  liveTrackerDriversListSearch: "live-tracker-drivers-list-search",
} as const;
